
import {getBrowserLocale, getPrefferedLocal} from './locale';
import i18njson from '../locales/i18n.json';


const supportedTranslations = new Map();

function separateLocales(translations) {
  translations.forEach((item) => {
      const key = item['Key'];
      for (let prop in item) {
          //////console.log('=> separateLocales.property ' + prop + ' / ' + item[prop]);
          if(prop !== 'Key') {
              const locale = prop;
              //////console.log('=> separateLocales.locale ' + locale);
              const i18nJson = supportedTranslations.get(locale) ? supportedTranslations.get(locale) : {};
              i18nJson[key] = item[prop];
              supportedTranslations.set(locale, i18nJson);
          }
      } 
  });
}

separateLocales(i18njson['Sheet1']);

const getTranslations = (key,localeDetails = false) => {
  const browserLocale = getBrowserLocale();
  const locale = getPrefferedLocal(browserLocale,supportedTranslations);

  //const locale = supportedTranslations.get(getBrowserLocale()) ? getBrowserLocale() : 'en-US';
  const activeTranslation = supportedTranslations.get(locale);
  let localizedString = activeTranslation[key] ? activeTranslation[key] : key;
  if(localeDetails) return locale;
 else  return localizedString;
};

export default getTranslations;